import React from 'react';
import { Grid, Card, Header, Segment, Label, Table } from 'semantic-ui-react'
import {
  capitalize as _capitalize,
  orderBy as _orderBy
} from 'lodash';

import './RequestInfo.less'

class RequestInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  get formPages() {
    const { serviceRequestInfo } = this.props || {};
    if (!serviceRequestInfo) {
      return [];
    }
    return _orderBy(serviceRequestInfo.formPages, 'pageOrder');
  }

  getSortedSection = (page = {}) => {
    const { sections } = page;
    if (!sections) {
      return [];
    }
    return _orderBy(sections, 'sectionOrder');
  };

  render() {

    const renderSections = (page, pi) => {
      const sections = this.getSortedSection(page).filter((section) => {return section.isHidden != true });

      return (<React.Fragment key={`sfd_page_${pi}`}>

        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {sections.map((section, si) => {
                let { fields = [] } = section;
                fields = [...fields.filter((field) => {return field.isHidden != true})]
                if (section.type === 'radio') {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid>
                    <Grid.Row>
                      <Grid.Column width={16} className="content-column">
                        {fields.map((field) => {
                          if (field.value === 'checked') {
                            return <p>{field.name}</p>;
                          }
                          return null;
                        })}
                      </Grid.Column>
                      </Grid.Row>
                    </Grid>

                  </div>)
                }
                else if (section.type == 'multi') {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid>
                    <Grid.Row>
                      {fields.map((field, fi) => {

                        return (<Grid.Column computer={4} tablet={8} mobile={16} className="content-column" >
                          <p>{_capitalize(field.name)}</p>
                          <div className="value">{field.value == 'checked' ? "Yes" : "No"}</div>
                        </Grid.Column>
                        )
                      })}
                      </Grid.Row>
                    </Grid>
                  </div>)
                }
                else {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid>
                      <Grid.Row>
                      {fields.map((field, fi) => {
                        return (<Grid.Column computer={4} mobile={8} className="content-column">
                            <p> {_capitalize(field.name)}</p>
                            <div className="value">{field.value}</div>
                          </Grid.Column>
                        )
                      })}
                      </Grid.Row>
                    </Grid>
                  </div>)
                }
              })
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>

        
      </React.Fragment>)
    }

    return (
      <div className="request-info">
        {this.props.title ? <h2>{this.props.title}</h2> : ''}
        {this.formPages.map((page, pi) => renderSections(page, pi))}
      </div>
    )
  }
}

export default RequestInfo;